import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Message from '../../v2/components/ui/Message/Message';
import Translation from '../../v2/lang/Translation';
import {isMobile} from '../../v2/selectors/DeviceSelectors';
import orderSummaryBasketItemsSelector from '../../v2/selectors/orderSummaryBasketItemsSelector';
import {getOrderSummary, getSettings, getSiteDataV2} from '../../v2/selectors/selectors';
import Spacing from '../../v2/style-helper/Spacing';
import replaceHTMLEntityWithSymbol from '../../v2/utils/replace-html-entity-with-symbol';
import SubscriptionInformationTable from '../SubscriptionInformationTable/SubscriptionInformationTable';

const useStyles = createUseStyles({
  subscriptionInfoMsgInfoBox: {
    marginTop: props => !props.isModal && Spacing.double,
  },
  introMessage: {
    marginBottom: Spacing.double,
    marginTop: Spacing.double,
    marginLeft: 0,
  },
  totalPaidMessage: {
    fontWeight: 'bold',
  },
  tAndCMessages: {
    fontSize: 12,
  },
});

export function SubscriptionInformationContent(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  const subscriptionItemTotalPriceFormatted = replaceHTMLEntityWithSymbol(props.subscriptionItemTotalPriceFormatted);
  
  return (
    <div data-test="SubscriptionInformationContent">
      <div className={classes.subscriptionInfoMsgInfoBox} data-test="SubscriptionInformation__subscriptionInfoMsgInfoBox">
        <Message>
          <Translation placeholderValues={[props.siteName]}>
            checkout.subscription.information.section.info.box.message.text
          </Translation>
        </Message>
      </div>
      
      <div className={classes.introMessage}>
        <p data-test="SubscriptionInformation__introMessage">
          <Translation placeholderValues={[props.siteName]}>
            checkout.subscription.information.section.intro.message.text
          </Translation>
        </p>
      </div>
      
      <SubscriptionInformationTable basketItems={props.basketItems} isMobile={props.isMobile} />
  
      <p className={classes.totalPaidMessage} data-test="SubscriptionInformation__totalPaidMessage">
        <Translation placeholderValues={[subscriptionItemTotalPriceFormatted]}>
          checkout.subscription.information.section.totalPaid.text
        </Translation>
      </p>
      
      <div className={classes.tAndCMessages}>
        <p data-test="SubscriptionInformation__deliveryDatesMessage">
          <Translation placeholderValues={[props.siteName]}>
            checkout.subscription.information.section.delivery.dates.text.line1
          </Translation>
        </p>
        
        <p data-test="SubscriptionInformation__deliveryDatesMessage">
          <Translation placeholderValues={[props.siteName]}>
            checkout.subscription.information.section.delivery.dates.text.line2
          </Translation>
        </p>
        
        <p data-test="SubscriptionInformation__deliveryDatesMessage">
          <Translation placeholderValues={[props.siteName]}>
            checkout.subscription.information.section.delivery.dates.text.line3
          </Translation>
        </p>
      </div>
    </div>
  );
}

SubscriptionInformationContent.propTypes = ({
  basketItems: PropTypes.arrayOf(PropTypes.object),
  isMobile: PropTypes.bool,
  siteName: PropTypes.string.isRequired,
  subscriptionItemTotalPriceFormatted: PropTypes.string.isRequired,
});

const mapStateToProps = (state) => {
  const orderSummary = getOrderSummary(state);
  
  return {
    basketItems: orderSummaryBasketItemsSelector(state),
    isMobile: isMobile(state),
    siteName: getSettings(state)?.subscription_info_message_sitename || getSiteDataV2(state)?.siteName,
    subscriptionItemTotalPriceFormatted: orderSummary?.subscriptionItemTotalPrice?.formatted,
  };
};

export default connect(mapStateToProps)(SubscriptionInformationContent);
